import { CrmAPIList } from '@/api'
import Moment from 'moment';

const api = new CrmAPIList();

export default {
  getCalendar({ state }, param) {
    return new Promise((resolve, reject) => {
      api.getCalendar(param, (json) => {
        resolve(json.data);
      }, (err) => {
        reject(err);
      });
    });
  },

  createLead({ state }, param) {
    return new Promise((resolve, reject) => {
      api.createLead(param, (json) => {
        resolve(json.data);
      }, (err) => {
        reject(err);
      });
    });
  },

  editLead({ state }, param) {
    return new Promise((resolve, reject) => {
      api.editLead(param, (json) => {
        resolve(json.data);
      }, (err) => {
        reject(err);
      });
    });
  },

  getLeadList({ state }, param) {
    return new Promise((resolve, reject) => {
      api.getLeadList(param, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },

  getCustomerList({ state }, param) {
    return new Promise((resolve, reject) => {
      api.getCustomerList(param, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },

  leadToCustomer({ state }, param) {
    return new Promise((resolve, reject) => {
      api.leadToCustomer(param, (json) => {
        resolve(json.data);
      }, (err) => {
        reject(err);
      });
    });
  },

  createCustomer({ state }, param) {
    return new Promise((resolve, reject) => {
      api.createCustomer(param, (json) => {
        resolve(json.data);
      }, (err) => {
        reject(err);
      });
    });
  },

  editCustomer({ state }, param) {
    return new Promise((resolve, reject) => {
      api.editCustomer(param, (json) => {
        resolve(json.data);
      }, (err) => {
        reject(err);
      });
    });
  },

  getNotification({state,commit}, param=[]){  // Header Notification Bubble
     return new Promise((resolve, reject) => {
      let params = [];
      if(param instanceof Array){
        params = params.concat(param);
      }
      api.getNotification(params, (json) => {        
        resolve(json.data);
      }, (err) => {
        reject(err);
      });
    });
  },

 getNotificationList({state,commit}, param=[]){  // Header Notification Bubble
     return new Promise((resolve, reject) => {
      let params = [];
      if (!(param instanceof Array) && Object.keys(param).length != 0) {
        for(var obj in param){
          params.push( {key:obj, value:param[obj]});
          if(obj == 'category'){
            commit('setNotificationCategory', { category: param[obj] });
          }
        }
      }
      api.getNotification(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },

  notifyMessageByID({state}, param){
    return new Promise((resolve, reject) => {
      let params= {};
      if(param instanceof Array){
        params['ID[]'] = param;
      }else{
        params.ID = param;
      }
      api.notifyMessage(params, (json) => {
        resolve(json.data);
      }, (err) => {
        reject(err);
      });
    });
  },

    notifyMessageByDate({state}, param){
    return new Promise((resolve, reject) => {
      api.notifyMessage(param, (json) => {
        resolve(json.data);
      }, (err) => {
        reject(err);
      });
    });
  },


  getAppointment({state}, param){
    return new Promise((resolve, reject) => {
      api.getAppointment(param, (json) => {
        resolve(json.data);
      }, (err) => {
        reject(err);
      });
    });
  },

   createAppointment({state}, param){
    return new Promise((resolve, reject) => {
      api.createAppointment(param, (json) => {
        resolve(json.data);
      }, (err) => {
        reject(err);
      });
    });
  },
   editAppointment({state}, param){
    return new Promise((resolve, reject) => {
      api.editAppointment(param, (json) => {
        resolve(json.data);
      }, (err) => {
        reject(err);
      });
    });
  },
   deleteAppointment({state}, param){
    return new Promise((resolve, reject) => {
      api.deleteAppointment(param, (json) => {
        resolve(json.data);
      }, (err) => {
        reject(err);
      });
    });
  },


}



// WEBPACK FOOTER //
// ./src/Crm/store/actions.js